import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  TextField,
  Button,
  CircularProgress,
  Box,
  Autocomplete,
} from '@mui/material';
import FutureDatetimeTextField from '../../forms/FutureDatetimeTextField';
import FutureDateTextField from '../../forms/FutureDateTextField';
import {
  nowDatetimeLocal,
  nowDateLocal,
  getMinEndDatetimeLocal,
} from '../../../utils/datetimeLocal';

const StatusDialog = ({
  open,
  selectedLead,
  newStatus,
  conditionalData,
  statusOptions,
  frontSellerOptions,
  processingId,
  onClose,
  onStatusChange,
  onNewStatusChange,
  onConditionalChange,
}) => {
  // const getSelectedAssignee = () => {
  //   return frontSellerOptions.find(seller => seller.id === conditionalData?.assignee_id) || null;
  // };

  // const handleAssignToChange = (event, value) => {
  //   onConditionalChange('assignee_id', value ? value.id : '');
  // };

  const getSelectedAssignee = () => {
    return frontSellerOptions.filter(
      seller => conditionalData?.assignees?.includes(seller.id)
    ) || [];
  };

  const selectedStatus = statusOptions.find((s) => s.id === newStatus);
  const statusName = selectedStatus?.name;

  const timeZones = ["UTC", "EST", "PST", "CST", "GMT"];

  useEffect(() => {
    if (!open) return;
    if (statusName === 'Meeting') {
      if (!conditionalData.startDateTime) {
        onConditionalChange('startDateTime', nowDatetimeLocal());
      }
      if (!conditionalData.endDateTime) {
        onConditionalChange(
          'endDateTime',
          getMinEndDatetimeLocal(conditionalData.startDateTime || nowDatetimeLocal())
        );
      }
    } else if (statusName && !conditionalData.date) {
      onConditionalChange('date', nowDateLocal());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional dependency list
  }, [open, statusName]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Change Lead Status</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <Autocomplete
            options={statusOptions}
            getOptionLabel={(option) => option.name || ""}
            value={statusOptions.find(s => s.id === newStatus) || null}
            onChange={(e, value) => onNewStatusChange(value?.id || "")}
            renderInput={(params) => (
              <TextField {...params} label="Status" />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        </FormControl>

        {/* SELECT Status Fields */}
        {statusName !== 'Meeting' && statusName && (
          <Box sx={{ mt: 3, gap: 2, display: 'flex', flexDirection: 'column' }}>
            <FutureDateTextField
              label="Date"
              value={conditionalData.date}
              onChange={(v) => onConditionalChange('date', v)}
              fullWidth
            />
            <TextField
              label="Description"
              multiline
              rows={3}
              value={conditionalData.description}
              onChange={(e) => onConditionalChange('description', e.target.value)}
              placeholder="Reason / notes…"
              fullWidth
            />
          </Box>
        )}

        {/* MEETING Status Fields */}
        {statusName === 'Meeting' && (
          <Box sx={{ mt: 3, gap: 2, display: 'flex', flexDirection: 'column' }}>
            {/* <FormControl fullWidth>
              <Autocomplete
                options={frontSellerOptions}
                getOptionLabel={(option) => option.name}
                value={getSelectedAssignee()}
                onChange={handleAssignToChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select assignee"
                    label="Select assignee"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="No assignee found"
              />
            </FormControl> */}

            <FormControl fullWidth>
              <Autocomplete
                multiple
                options={frontSellerOptions}
                getOptionLabel={(option) => option.name}
                value={getSelectedAssignee()}
                onChange={(e, value) =>
                  onConditionalChange(
                    "assignees",
                    value.map(v => v.id)
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select assignee"
                    label="Select assignees"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                noOptionsText="No assignee found"
              />
            </FormControl>

            <FormControl fullWidth>
              <Autocomplete
                options={timeZones}
                value={conditionalData.timeZone || null}
                onChange={(e, value) => onConditionalChange("timeZone", value)}
                renderInput={(params) => (
                  <TextField {...params} label="Time Zone" />
                )}
              />
            </FormControl>
            
            <FutureDatetimeTextField
              label="Start Date & Time"
              value={conditionalData.startDateTime}
              onChange={(v) => onConditionalChange('startDateTime', v)}
              fullWidth
            />

            <FutureDatetimeTextField
              label="End Date & Time"
              value={conditionalData.endDateTime}
              onChange={(v) => onConditionalChange('endDateTime', v)}
              minDatetime={getMinEndDatetimeLocal(conditionalData.startDateTime)}
              fullWidth
            />
            
            <TextField
              label="Meeting Description"
              multiline
              rows={3}
              value={conditionalData.meetingDescription}
              onChange={(e) => onConditionalChange('meetingDescription', e.target.value)}
              placeholder="Agenda, purpose…"
              fullWidth
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onStatusChange}
          variant="contained"
          disabled={!newStatus || processingId === selectedLead?.id}
          startIcon={processingId === selectedLead?.id ? <CircularProgress size={20} /> : null}
        >
          Update Status
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusDialog;